import * as React from 'react';
import { ProductBox } from '../modules';
import CountryService from '../../services/CountryService';

interface IVariantListProps {
  category?: GQL.ICategory | undefined;
  variants: Array<GQL.IProductVariant>;
  productTags?: Array<GQL.IProductTag>;
  hideTags?: string[];
  GTMItemListName?: string;
}

export const composeDivId = (id: string) => `variantList_${id.toLowerCase().replace(/\s+/g, '_')}`;

class VariantList extends React.Component<IVariantListProps> {

  public render() {
    const { category, variants, productTags, hideTags, GTMItemListName } = this.props;
    const { language } = CountryService.GetInstance();

    return (
      <React.Fragment>
        <div className="row no-gutters" id={GTMItemListName ? composeDivId(GTMItemListName) : undefined}>

          {variants &&
            variants.map((variant, i) => (
              <div key={i} className="productList__item col-12 col-xs-6 col-sm-4 col-lg-3">
                <ProductBox
                  language={language}
                  // isFavorite={favorites.favorites.some(
                  //   (v: GQL.IProductVariant) =>
                  //     v.id == variant.id
                  // )}
                  category={category}
                  // sizes={getAllSizesForVariant(
                  //   variant.product.id,
                  //   variant,
                  //   allProducts,
                  //   attributes.attributes.filter(({ tags }: any) => tags.includes('size')),
                  //   language,
                  //   selectedSubOptions
                  // )}
                  tags={productTags}
                  hideTags={hideTags}
                  // onToggleFavorite={async vId => {
                  //   await this.toggleFavorite(vId);
                  //   await favorites.refetch();
                  // }}
                  variant={variant}
                  boxType="buy"
                  GTMItemListName={GTMItemListName}
                />
              </div>
            ))}
        </div>
      </React.Fragment>
    );
  }
}

export default VariantList;


// WEBPACK FOOTER //
// ./src/modules/VariantList/VariantList.tsx